// Live figures read from the owner's Google Business listings on 2026-11-04.
export const GOOGLE_LISTINGS = [
  { id: "kota", name: "Garg Stone Company", place: "Kota · IPIA", score: "5.0", count: 45, url: "https://maps.google.com/?cid=4756032706190950519" },
  { id: "ramganj-mandi", name: "Garg Minerals", place: "Ramganj Mandi", score: "5.0", count: 4, url: "https://maps.google.com/?cid=11094439554701431975" },
];

export const PRIMARY_LISTING = GOOGLE_LISTINGS[0];

// Verbatim excerpts from the Kota Google listing (read 2026-06). Add more as { author, text, when }.
export const REVIEWS = [
  { author: "Lakshita Lohar", when: "Google review", text: "Excellent quality and professionalism. Mr. Aditya is extremely knowledgeable, polite and genuinely commited towards his work. He values integrity and long term business relationships. Rare to see such sincerity and dedication these days." },
  { author: "Arihant Jain", when: "Local Guide", text: "I recently purchased materials from Garg Stone Company and was extremely satisfied with the entire experience." },
  { author: "Dr Lokesh Singhal", when: "Google review", text: "Good material received by Aditya ..rates provide by him is also good" },
];
